export const backToTopButtonMetaData = {
    mobileOnly: true
}
